import _sfc_main from './bgm-container.vue2.js';
/* empty css                  */
import _export_sfc from '../../../_virtual/_plugin-vue_export-helper.js';

const BgmContainer = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-967c3c86"]]);

export { BgmContainer as default };
//# sourceMappingURL=bgm-container.js.map
